import { useEffect } from "react";
import { Mail, Phone } from "lucide-react";

const Kvkk = () => {
  useEffect(() => {
    document.title = "KVKK Aydınlatma Metni | Reklam Uzmanı";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Reklam Uzmanı KVKK Aydınlatma Metni. 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında bilgilendirme.');
    }
    
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);
    
    window.scrollTo(0, 0);
    
    return () => {
      document.head.removeChild(metaRobots);
    };
  }, []);

  return (
    <div className="bg-white min-h-screen pt-20">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#012f23] to-[#059669] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            KVKK Aydınlatma Metni
          </h1>
          <p className="text-gray-200 text-lg">
            6698 Sayılı Kişisel Verilerin Korunması Kanunu Kapsamında Bilgilendirme
          </p>
          <p className="text-gray-200 mt-2">
            Son Güncelleme: 16 Ekim 2025
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-10">
            <p className="text-gray-800 leading-relaxed">
              6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verilerinizin işlenmesine ilişkin olarak sizleri bilgilendirmek amacıyla bu aydınlatma metni hazırlanmıştır.
            </p>
          </div>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              1. Veri Sorumlusunun Kimliği
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-3">
              <p>
                <strong>Ticari Unvan:</strong> Reklam Uzmanı
              </p>
              <p>
                <strong>Sorumlu Kişi:</strong> Reklam Uzmanı Ekibi (Google Ads Uzmanı)
              </p>
              <p>
                <strong>Faaliyet Alanı:</strong> Google Ads Yönetimi ve Performans Pazarlama Hizmetleri
              </p>
              <p>
                <strong>Adres:</strong> Adnan Kahveci, Yavuz Sultan Selim Blv. uyum çarşı içi kat 1 iç kapı no 72, 34528 Beylikdüzü/İstanbul
              </p>
              <p>
                <strong>E-posta:</strong> info@reklam-uzmani.com.tr
              </p>
              <p>
                <strong>Telefon:</strong> +90 535 838 62 97
              </p>
              <p>
                <strong>Web Sitesi:</strong> https://reklamuzmani.tr
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              2. Kişisel Verilerin İşlenme Amaçları
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Google Ads reklam yönetimi hizmetlerinin sunulması ve sözleşmelerin ifası</li>
                <li>Müşteri ilişkileri yönetimi ve iletişim faaliyetlerinin yürütülmesi</li>
                <li>Teklif hazırlama, fiyatlandırma ve ön görüşme süreçlerinin yönetilmesi</li>
                <li>Fatura, ödeme ve sözleşme süreçlerinin yürütülmesi</li>
                <li>Hizmet kalitesinin artırılması ve müşteri memnuniyetinin sağlanması</li>
                <li>Pazarlama ve iletişim faaliyetlerinin gerçekleştirilmesi (açık rızanız dahilinde)</li>
                <li>Google Ads kampanya yönetimi ve optimizasyonu (Arama Ağı, Haritalar, YouTube, Display Network)</li>
                <li>Web sitesi performans analizi ve kullanıcı deneyimi iyileştirmeleri</li>
                <li>İstatistiksel analiz ve raporlama çalışmaları</li>
                <li>Hukuki yükümlülüklerin yerine getirilmesi ve yasal taleplere cevap verilmesi</li>
                <li>İç denetim ve güvenlik süreçlerinin yürütülmesi</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              3. İşlenen Kişisel Veri Kategorileri
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Hizmetlerimizi sunabilmek için aşağıdaki kişisel veri kategorileri işlenmektedir:
              </p>

              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    3.1. Kimlik Bilgileri
                  </h3>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Ad, soyad</li>
                    <li>T.C. Kimlik Numarası (fatura gerektiren işlemlerde)</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    3.2. İletişim Bilgileri
                  </h3>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>E-posta adresi</li>
                    <li>Cep telefonu numarası</li>
                    <li>Adres bilgisi</li>
                    <li>WhatsApp iletişim bilgileri</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    3.3. İşletme/Firma Bilgileri
                  </h3>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Firma unvanı</li>
                    <li>Faaliyet alanı</li>
                    <li>İşletme adresi</li>
                    <li>Google İşletme Profili bilgileri</li>
                    <li>Vergi dairesi ve vergi numarası</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    3.4. Müşteri İşlem Bilgileri
                  </h3>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Sözleşme bilgileri</li>
                    <li>Hizmet paket tercihleri</li>
                    <li>Ödeme bilgileri (banka hesap bilgileri, fatura bilgileri)</li>
                    <li>İletişim kayıtları (e-posta, telefon görüşmeleri, WhatsApp mesajları)</li>
                    <li>Hizmet talep ve şikayet kayıtları</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    3.5. Pazarlama Bilgileri
                  </h3>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>E-posta ve SMS izin durumu</li>
                    <li>İlgi alanları ve tercihler</li>
                    <li>Kampanya katılım bilgileri</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    3.6. Dijital İz ve Teknik Bilgiler
                  </h3>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>IP adresi</li>
                    <li>Çerez verileri</li>
                    <li>Tarayıcı bilgileri</li>
                    <li>Cihaz bilgileri</li>
                    <li>Web sitesi ziyaret kayıtları</li>
                    <li>Sayfa görüntüleme ve tıklama verileri</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              4. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebepleri
            </h2>
            <div className="text-gray-700 leading-relaxed">
              
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                4.1. Toplama Yöntemleri
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Web sitesi iletişim formları</li>
                <li>E-posta yazışmaları</li>
                <li>Telefon ve WhatsApp görüşmeleri</li>
                <li>Sözleşme ve anlaşma süreçleri</li>
                <li>Çerezler ve benzer teknolojiler (Google Analytics, Google Ads, Meta Pixel)</li>
                <li>Sosyal medya platformları</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                4.2. Hukuki Sebepler (KVKK m.5 ve m.6)
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Sözleşmenin kurulması ve ifası:</strong> Hizmet sunumu için gerekli işlemler</li>
                <li><strong>Hukuki yükümlülüğün yerine getirilmesi:</strong> Vergi, ticaret, muhasebe mevzuatı</li>
                <li><strong>Meşru menfaat:</strong> İş geliştirme, müşteri ilişkileri yönetimi</li>
                <li><strong>Açık rıza:</strong> Pazarlama iletişimi, veri paylaşımı gerektiren durumlar</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              5. Kişisel Verilerin Aktarılması
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Kişisel verileriniz, KVKK'nın 8. ve 9. maddelerinde belirtilen şartlar çerçevesinde aşağıdaki alıcılara aktarılabilir:
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                5.1. Yurt Dışına Veri Aktarımı
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Google LLC (Amerika Birleşik Devletleri):</strong> Google Analytics (web sitesi analizi), Google Ads API (reklam optimizasyonu), YouTube Ads ve Display Network yönetimi
                </li>
              </ul>
              <p className="mt-3 text-sm italic">
                * Bu platformlar, GDPR uyumlu veri koruma standartlarına sahiptir ve verileriniz yalnızca belirtilen amaçlar doğrultusunda işlenir.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                5.2. Yurt İçi Veri Aktarımı
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Ödeme Kuruluşları ve Bankalar:</strong> Fatura ve ödeme işlemleri</li>
                <li><strong>Muhasebe ve Mali Müşavirlik Hizmetleri:</strong> Yasal muhasebe yükümlülükleri</li>
                <li><strong>Bulut Hizmet Sağlayıcıları:</strong> Veri saklama ve yedekleme</li>
                <li><strong>Hukuk Büroları:</strong> Hukuki danışmanlık ve uyuşmazlık çözümü</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                5.3. Kamu Kurum ve Kuruluşları
              </h3>
              <p className="mb-2">
                Yasal zorunluluklar çerçevesinde aşağıdaki kurumlara veri aktarımı yapılabilir:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Mahkemeler ve icra daireleri</li>
                <li>Vergi daireleri</li>
                <li>Emniyet ve kolluk kuvvetleri</li>
                <li>Kişisel Verileri Koruma Kurumu</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              6. Kişisel Veri Sahibinin Hakları (KVKK m.11)
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                KVKK'nın 11. maddesi uyarınca, kişisel veri sahibi olarak aşağıdaki haklara sahipsiniz:
              </p>

              <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 space-y-4">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    ✓ Bilgi Edinme Hakkı
                  </h3>
                  <p className="text-sm">
                    Kişisel verilerinizin işlenip işlenmediğini öğrenme hakkı
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    ✓ Bilgi Talep Etme Hakkı
                  </h3>
                  <p className="text-sm">
                    Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme hakkı
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    ✓ İşlenme Amacını Öğrenme Hakkı
                  </h3>
                  <p className="text-sm">
                    Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme hakkı
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    ✓ Aktarım Bilgisi Edinme Hakkı
                  </h3>
                  <p className="text-sm">
                    Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme hakkı
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    ✓ Düzeltme Hakkı
                  </h3>
                  <p className="text-sm">
                    Kişisel verilerin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme hakkı
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    ✓ Silme ve Yok Etme Hakkı
                  </h3>
                  <p className="text-sm">
                    Kişisel verilerin silinmesini veya yok edilmesini isteme hakkı (KVKK'da öngörülen şartlar dahilinde)
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    ✓ Bildirme Hakkı
                  </h3>
                  <p className="text-sm">
                    Düzeltme, silme veya yok etme işlemlerinin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme hakkı
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    ✓ İtiraz Hakkı
                  </h3>
                  <p className="text-sm">
                    İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme hakkı
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    ✓ Tazminat Hakkı
                  </h3>
                  <p className="text-sm">
                    Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini talep etme hakkı
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              7. Başvuru Yöntemi ve Süreci
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Yukarıda belirtilen haklarınızı kullanmak için aşağıdaki yöntemlerle Reklam Uzmanı'na başvurabilirsiniz:
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                7.1. Başvuru Kanalları
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>E-posta:</strong> info@reklam-uzmani.com.tr adresine "KVKK Başvurusu" konulu e-posta gönderebilirsiniz
                </li>
                <li>
                  <strong>Posta:</strong> Adnan Kahveci, Yavuz Sultan Selim Blv. uyum çarşı içi kat 1 iç kapı no 72, 34528 Beylikdüzü/İstanbul adresine iadeli taahhütlü mektup gönderebilirsiniz
                </li>
                <li>
                  <strong>Telefon:</strong> +90 535 838 62 97 numaralı telefonu arayarak bilgi alabilirsiniz
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                7.2. Başvuruda Bulunması Gereken Bilgiler
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Ad, soyad ve imza</li>
                <li>T.C. kimlik numarası (Türkiye Cumhuriyeti vatandaşları için)</li>
                <li>Pasaport numarası veya benzeri kimlik belgesi (yabancı uyruklu kişiler için)</li>
                <li>Tebligata esas yerleşim yeri veya iş yeri adresi</li>
                <li>E-posta adresi, telefon ve faks numarası</li>
                <li>Talep konusu (net ve anlaşılır bir şekilde)</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                7.3. Başvuru Değerlendirme Süresi
              </h3>
              <p className="mb-4">
                Başvurularınız, talebin niteliğine göre <strong>en geç 30 gün içinde</strong> ücretsiz olarak sonuçlandırılacaktır. Ancak, işlemin ayrıca bir maliyeti gerektirmesi halinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret alınabilir.
              </p>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-4">
                <p className="text-sm text-gray-800">
                  <strong>Önemli Not:</strong> Başvurunuzun kimlik doğrulaması yapıldıktan sonra işleme alınacağını, bu nedenle kimlik tespitine yarayan belgelerin eksiksiz iletilmesi gerektiğini hatırlatmak isteriz.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              8. Veri Saklama Süreleri
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Kişisel verileriniz, işlenme amaçları doğrultusunda gerekli olan süre boyunca ve yasal saklama yükümlülükleri çerçevesinde saklanır:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Müşteri Sözleşme ve Fatura Bilgileri:</strong> Hizmet süresi + 10 yıl (Vergi Usul Kanunu, Türk Ticaret Kanunu)</li>
                <li><strong>İletişim ve Talep Bilgileri:</strong> İşlem tamamlanana kadar veya talep geri çekilene kadar</li>
                <li><strong>Pazarlama İzinleri:</strong> Açık rıza geri çekilene kadar (maksimum 2 yıl)</li>
                <li><strong>Çerez ve Analiz Verileri:</strong> 2 yıl (Google ve Meta politikalarına uygun olarak)</li>
                <li><strong>Hukuki Uyuşmazlık Kayıtları:</strong> Zamanaşımı süreleri boyunca</li>
              </ul>
              <p className="mt-4 text-sm italic">
                Saklama sürelerinin sona ermesi halinde, kişisel verileriniz silinir, yok edilir veya anonim hale getirilir.
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              9. Veri Güvenliği
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                KVKK'nın 12. maddesi uyarınca, kişisel verilerinizin hukuka aykırı işlenmesini ve erişimini önlemek, güvenli bir şekilde saklanmasını sağlamak amacıyla uygun güvenlik önlemleri alınmıştır:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>SSL/TLS şifreleme protokolleri</li>
                <li>Güvenli sunucu altyapısı ve firewall sistemleri</li>
                <li>Düzenli güvenlik güncellemeleri ve yamalar</li>
                <li>Yetkilendirme ve erişim kontrol sistemleri</li>
                <li>Düzenli veri yedekleme</li>
                <li>Personel eğitimleri ve gizlilik taahhütnameleri</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              10. Aydınlatma Metninde Değişiklikler
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p>
                Bu KVKK Aydınlatma Metni, yasal düzenlemelerdeki değişiklikler, şirket politikalarındaki güncellemeler veya operasyonel ihtiyaçlar doğrultusunda güncellenebilir. Önemli değişiklikler yapıldığında, web sitemiz üzerinden ve mümkün olan durumlarda size doğrudan bilgilendirme yapılacaktır.
              </p>
              <p className="mt-3">
                Düzenli olarak bu sayfayı ziyaret ederek güncel metni incelemenizi öneririz.
              </p>
            </div>
          </section>

        </div>

        {/* İletişim CTA */}
        <div className="mt-12 p-6 bg-gradient-to-r from-[#012f23] to-[#059669] rounded-lg text-white">
          <h3 className="text-xl font-bold mb-3">
            KVKK Haklarınızı Kullanın
          </h3>
          <p className="mb-4 text-gray-100">
            Kişisel verileriniz ve yasal haklarınız hakkında bilgi almak için bizimle iletişime geçin.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="mailto:iletisim@reklamuzmani.tr"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#012f23] rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              <Mail className="w-5 h-5" />
              iletisim@reklamuzmani.tr
            </a>
            <a
              href="tel:05326369115"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#012f23] rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              <Phone className="w-5 h-5" />
              0532 636 91 15
            </a>
          </div>
          <p className="mt-4 text-sm text-gray-200">
            Başvurularınız en geç 30 gün içinde yanıtlanacaktır.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Kvkk;
